
import { ToastContainer } from "react-toastify";

import AppRouter from "./AppRouter";



function App() {
 
 
  return (
   <div className=" overflow-x-hidden">
 <ToastContainer />
      <AppRouter />
     
   </div>
     

  );
}

export default App;